import { useI18N } from "common/hooks";
import AddPhotosCta from "@/components/VenueDetailBasic/AddPhotosCta";
import { useFooterSettings } from "common/hooks";
import footerDataFallback from "@/components/Footer/footerData.json";

/**
 * Shown in the accessibility slot when a venue has nothing mapped yet.
 * Contributing photos is a mobile-app capability, so the desktop CTA is inert
 * and the QR block is the real call to action.
 */
export default function AddPhotosEmptyState() {
  const i18n = useI18N();
  const { footerSettings } = useFooterSettings();
  const footerData = footerSettings || footerDataFallback;

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-4 py-8">
      <p className="text-center title-s-semibold text-fg-neutral-strong">
        {i18n.get("beTheFirstToAddPhotos")}
      </p>
      <p className="text-center label-s-regular text-fg-neutral-subtle mt-1">
        {i18n.get("addPhotosFromYourVisitUsingTheApp")}
      </p>

      {/* Add photos — inert on desktop: the flow only exists in the app. */}
      <div className="mt-6 w-[300px]">
        <AddPhotosCta />
      </div>

      {/* Scan to get the app — desktop only. On a phone you cannot scan a QR
          code with the device you are already holding, and the native layout
          omits it here too. */}
      <div className="mt-4 hidden lg:flex w-[300px] flex-col items-center gap-4 rounded-2xl bg-surface-secondary p-6 text-center">
        <p className="label-m-medium text-fg-neutral-medium">
          {i18n.get("scanTheQRCodeToDownloadTheApp")}
        </p>
        <img
          src="/images/Sociability_App_Download_QR_Code.png"
          alt="QR code to download Sociability app"
          className="h-[120px] w-[120px] rounded-lg"
        />
        <div className="flex items-center justify-center gap-3">
          {footerData.appStoreLinks.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="focus-blue inline-flex h-10 w-[120px] shrink-0 items-center justify-center transition-opacity hover:opacity-80"
              aria-label={i18n.t(link.ariaLabelKey)}
            >
              <img
                src={link.image}
                alt={i18n.t(link.ariaLabelKey)}
                className="h-full w-full object-contain"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
